import React from 'react'

export const Mapping = [
	{
		title: "BSPSource",
		link: "https://github.com/ata4/bspsrc/releases",
		description: "Tool for decompiling maps and extracting all embeded files"
	},
	{
		title: "BSPZIP",
		link: "https://developer.valvesoftware.com/wiki/BSPZIP",
		description: "Command line tool that allows arbitrary files to be embedded within a BSPSource"
	},
	{
		title: "CompilePal",
		link: "https://compilepal.ruar.ai/",
		description: "Compiling tool, useful for autopacking and compiling presets"
	},
	{
		title: "Pakrat",
		link: "http://www.bagthorpe.org/bob/cofrdrbob/pakrat.html",
		description: "Legacy packing tool for BSP files (WARNING: Can Corrupt BSP)"
	},
	{
		title: "Crowbar",
		link: "https://github.com/ZeqMacaw/Crowbar",
		description: "All in one modding tool"
	},
	{
		title: "Goldwave",
		link: "https://www.goldwave.com/",
		description: "Creating soundscapes (more info at https://developer.valvesoftware.com/wiki/Looping_a_Sound)"
	},
	{
		title: "EntSpy",
		link: "http://www.bagthorpe.org/bob/cofrdrbob/entspy.html",
		description: "Tool to edit entities in compiled maps"
	},
	{
		title: "VIDE",
		link: "http://www.riintouge.com/VIDE/",
		description: "Embeding custom content into map files and features a mass-VTF/VMT editor"
	},
	{
		title: "SourceOps",
		link: "https://github.com/bonjorno7/SourceOps",
		description: "Blender tool which inports and exports model files for use in Hammer"
	},
	{
		title: "VTFEdit",
		link: "https://developer.valvesoftware.com/wiki/VTFEdit",
		description: "VTF and VMT creator/editor"
	},
	{
		title: "VMT Editor",
		link: "https://gira-x.github.io/VMT-Editor/",
		description: "Open Source editor for VMT files"
	},
	{
		title: "io_import_vmf",
		link: "https://github.com/lasa01/io_import_vmf",
		description: ".vmf and .vmt importer for blender"
	},
	{
		title: "Blender Source Tools",
		link: "https://steamreview.org/BlenderSourceTools/",
		description: "Import smd and shape keys into blender"
	},
	{
		title: "Source Model Skin Editor",
		link: "https://developer.valvesoftware.com/wiki/Source_model_skin_editor",
		description: "Allows you to add, edit, or delete skins on a Source engine model files"
	},
	{
		title: "Wall Worm",
		link: "https://wallworm.com/",
		description: "Pipeline tools for 3ds Max"
	},
	{
		title: "VTFVer",
		link: "https://developer.valvesoftware.com/wiki/VTFVer",
		description: "VTF texture converter for version 7.5 to 7.4 (Useful for porting)"
	},
	{
		title: "Propper",
		link: "https://github.com/tuxxi/propper-2013",
		description: "Edited VBSP that outputs models from Hammer Editor"
	},
	{
		title: "GCFScape",
		link: "https://gamebanana.com/tools/26",
		description: "GCF extraction tool"
	},
	{
		title: "SourceIO",
		link: "https://github.com/REDxEYE/SourceIO",
		description: "Blender addon for importing\exporting source engine textures/models/maps"
	},	
]

export const Guides = [
	{
		title: "TopHATTWaffle's Hammer Tutorial V1",
		link: "https://youtube.com/playlist?list=PL-454Fe3dQH3ro-IplCis_8zGO1BYYYNR",
		description: "Old Hammer tutorial series but covers more topics, recomended beginners"
	},
	{
		title: "TopHATTWaffle's Hammer Tutorial V2",
		link: "	https://youtube.com/playlist?list=PL-454Fe3dQH1L38FnKkz_O1CqYx6sKaXk",
		description: "More up to date Hammer Tutorial, recomended for beginners"
	},
	{
		title: "3kliksphilip's Hammer Tutorial",
		link: "https://youtube.com/playlist?list=PLfwtcDG7LpxF7-uH_P9La76dgCMC_lfk3",
		description: "Quick and straight to the point, most useful for a case by case bias "
	},
	{
		title: "Bletzkarn's Bhop Mapping Tutorial",
		link: "https://www.youtube.com/channel/UCM1Wx_Qw-M8vtjsIoXAlk5Q/videos",
		description: "Guide that goes through common techniques used in bhop maps"
	},
]
